import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {addSubField} from "../../../../../store/actions/subFields";
import{changeGroupField} from "../../../../../store/actions/groupFields";
import {connect} from "react-redux";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import ClassicCustomFieldsNotice from "../../../ClassicCustomFieldsNotice";
import {isCustomFieldValid} from "../../../ClassicFunctions";

const CustomFieldsFilter = (props) => {

	const {addSubField, group, changeGroupField, premium} = props;

	const newCustomField = {
		name:   'custom-field',
		label:  'Custom field',
		fields: [
			getFieldFactory().getSourceField(), getFieldFactory().getValueInputType(), {
				id:        'customFieldName',
				inputType: 'input',
				value:     '',
				label:     'Custom field name',
				dynamic:   false,
			}, getFieldFactory().getParametersField(), {
				id:           'compare',
				inputType:    'select',
				source:       'compareTypes',
				sourceName:   'name',
				sourceValue:  'value',
				value:        '',
				label:        'Compare',
				defaultValue: 'Select a comparison type',
				dynamic:      false
			}, {
				id:           'type',
				inputType:    'select',
				source:       'dataTypes',
				sourceName:   'name',
				sourceValue:  'value',
				value:        '',
				label:        'Type',
				defaultValue: 'Select a data type',
				dynamic:      false
			}, {
				id:           'queryGroup',
				inputType:    'select',
				source:       'queryGroups',
				sourceName:   'name',
				sourceValue:  'name',
				value:        '',
				label:        'Query Group',
				defaultValue: 'Select a group',
				dynamic:      false
			},
			getFieldFactory().getDynamicField()
		],
	};

	return (
		<React.Fragment>

			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (<React.Fragment>
					<h3>Custom Fields ({endpoint[action][currentItem].customFields.length})</h3>

					<p>Use this section for adding one or more custom field filters for your endpoint. You can set a fixed value or choose an already defined parameter.</p>

					<p>If you need to group some conditions, you should create a Query Group and then connect your meta fields.</p>

					<ParametersNotice parameters={endpoint.parameters}/>

					<label>Main relation type:</label>
					<select className="restroutes-select-small" value={endpoint[action][currentItem].mainRelationType} onChange={e => changeGroupField( endpointId, action, currentItem, 'mainRelationType', e.target.value )}>
						<option value="AND">AND</option>
						<option value="OR">OR</option>
					</select>

					<button onClick={() => (premium || isCustomFieldValid(endpoint[action][currentItem].customFields.length)) && addSubField(endpointId, [ newCustomField ], currentItem, group, action)} className="button-secondary">
						Add custom field filter
					</button>

          <ClassicCustomFieldsNotice />

					<FieldGroups group={group}/>

				</React.Fragment>)}
			</FieldGroupContext.Consumer>
		</React.Fragment>
	);
};

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
	changeGroupField: ( endpointId, group, index, field, value ) => dispatch( changeGroupField( endpointId, group, index, field, value ) )
});

export default connect( mapStateToProps, mapDispatchToProps )(CustomFieldsFilter);
